import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import ReactPaginate from 'react-paginate';
import ReactLoading from 'react-loading';
import Pluralize from 'react-pluralize';
import VehicleCard from './VehicleCard.js';
import ProdigySelect from '../../GlobalUI/ProdigySelect';
import { DefaultPaginationConfig } from './DefaultPaginationConfig';
import feedviewsActions from '../../../redux/feedviews/actions';
import carsActions from '../../../redux/cars/actions';
import { getFilteredCars } from '../../../redux/cars/selectors';
import '../Feedview.scss';

function FeedviewFiltersPreview(props) {
  const { feedview, actions, previewWhere, filteredCars, fetching, dealer } =
    props;
  const [displayFilteredCars, setDisplayFilteredCars] = useState([]);
  const [totalCars, setTotalCars] = useState(0);
  const [sortByValue, setSortByValue] = useState(null);
  const [sortKey, setSortKey] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [pagination, setPagination] = useState(
    cloneDeep(DefaultPaginationConfig),
  );
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  useEffect(() => {
    actions.getFilteredCarsRequest({
      ignoreCache: true,
      feedViewId: feedview.id,
      previewWhere,
      ...pagination,
      sortKey,
      sortDirection,
    });
  }, [actions, feedview.id, pagination, previewWhere, sortDirection, sortKey]);

  useEffect(() => {
    if (filteredCars?.data) {
      setDisplayFilteredCars(filteredCars?.data);
      setTotalCars(filteredCars?.total);
      setPageCount(Math.ceil((filteredCars?.total || 0) / pagination.limit));
      setCurrentPage(0);
    }
  }, [filteredCars, pagination.limit]);

  const handlePaginationChange = (data) => {
    const selected = data.selected;
    const offset = Math.ceil(selected * pagination.limit);
    const current = offset / pagination.limit + 1;
    pagination.offset = offset;
    pagination.current = current;
    setCurrentPage(current);
    setPagination(pagination);
    actions.getFilteredCarsRequest({
      ignoreCache: true,
      feedViewId: feedview.id,
      previewWhere,
      ...pagination,
      sortKey,
      sortDirection,
    });
  };

  const changeSortHandler = (sort) => {
    setSortByValue(sort.value);
    setSortKey(sort.value.sortKey);
    setSortDirection(sort.value.sortDirection);
    actions.getFilteredCarsRequest({
      ignoreCache: true,
      feedViewId: feedview.id,
      previewWhere,
      ...pagination,
      sortKey: sort.value.sortKey,
      sortDirection: sort.value.sortDirection,
    });
  };

  const getSortOptions = () => {
    const opts = [
      {
        label: 'Price Low to High',
        value: { sortKey: 'cachedOnlinePrice', sortDirection: 'asc' },
      },
      {
        label: 'Price High to Low',
        value: { sortKey: 'cachedOnlinePrice', sortDirection: 'desc' },
      },
    ];
    return opts;
  };

  const options = getSortOptions();

  return (
    <div className="row main-content-area">
      <div className="row title-area">
        <h3>
          Previewing{' '}
          <Pluralize
            singular=" Vehicle "
            plural=" Vehicles "
            count={totalCars}
          />
          filtered from current inventory of{' '}
          <Pluralize
            singular=" Feed "
            plural=" Feeds "
            count={feedview.Feeds.length}
          />
        </h3>
        <ProdigySelect
          id="sortBy"
          options={options}
          className="p-select p-select-sml"
          placeholder="Sort by..."
          onChange={changeSortHandler}
          value={sortByValue}
          searchable={false}
        />
      </div>

      {fetching && (
        <div className="vehicle-cards-container spinner-container">
          <ReactLoading
            type="bubbles"
            height="30%"
            width="30%"
            color="blue"
            className="vehicle-loading-image"
          />
        </div>
      )}
      {!fetching && (
        <Grid fluid className="vehicle-cards-container">
          {totalCars === 0 && (
            <div className="center-center">No Cars Found...</div>
          )}
          {displayFilteredCars.map((car, i) => (
            <VehicleCard
              key={car.id}
              vehicle={car}
              id={`vehicleCard-${i}`}
              dealer={dealer}
            />
          ))}
        </Grid>
      )}
      {totalCars > pagination.limit && (
        <div className="pagination-container">
          <div className="result-count-info" id="resultCountInfo">
            <span className="pagination-showing-label">Showing</span>
            {pagination.offset + 1} -{' '}
            {pagination.offset + displayFilteredCars.length} of {totalCars}
          </div>
          <ReactPaginate
            previousLabel="&laquo;"
            nextLabel="&raquo;"
            breakLabel="..."
            breakClassName="break-me"
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={handlePaginationChange}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
            initialPage={currentPage}
            disableInitialCallback
          />
        </div>
      )}
    </div>
  );
}

FeedviewFiltersPreview.propTypes = {
  feedview: PropTypes.array,
  actions: PropTypes.object,
  previewWhere: PropTypes.array,
  filteredCars: PropTypes.object,
  fetching: PropTypes.bool,
  dealer: PropTypes.object,
};

const mapStateToProps = (state) => ({
  filteredCars: getFilteredCars(state),
  fetching: state.cars.filteredCars.fetching,
  dealer: state?.deals?.dealer || state?.user?.currentUserDealer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedviewsActions,
      ...carsActions,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeedviewFiltersPreview);
